import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { peopleEllipsisSx, peopleHeaderDescriptionSx } from "../../peopleFormValidation";

export default function TeamDetailProfile({ team }) {
  return (
    <Box sx={{ minWidth: 0, maxWidth: "100%" }}>
      <Typography
        title={team.name}
        sx={{
          color: "#061522",
          fontFamily: "Inter",
          fontSize: 18,
          fontWeight: 500,
          lineHeight: "34px",
          ...peopleEllipsisSx,
        }}
      >
        {team.name}
      </Typography>
      {team.description ? (
        <Typography
          component="div"
          sx={{
            color: "#405261",
            fontFamily: "Inter",
            fontSize: 14,
            fontWeight: 400,
            lineHeight: "18px",
            mt: 0.5,
            ...peopleHeaderDescriptionSx,
          }}
        >
          {team.description.slice(0, 80)}...
        </Typography>
      ) : null}
    </Box>
  );
}
